import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import DeleteMembershipTypeAllowedTime from 'src/features/allowedTimes/components/forms/membershipType/DeleteMembershipTypeAllowedTime';
import UpdateMembershipTypeAllowedTimeFormModal from 'src/features/allowedTimes/components/forms/membershipType/UpdateMembershipTypeAllowedTimeFormModal';
import { AllowedTimes } from 'src/features/membershipType/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellMembershipTypeAllowedTimeActions({ row }: CellContext<AllowedTimes, unknown>) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <UpdateMembershipTypeAllowedTimeFormModal selectedAllowedTime={row.original}>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                </Button>
                            </UpdateMembershipTypeAllowedTimeFormModal>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <DeleteMembershipTypeAllowedTime selectedAllowedTime={row.original}>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                </Button>
                            </DeleteMembershipTypeAllowedTime>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>{' '}
        </div>
    );
}
